import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/Z1.css";

// ⭐ Example 5 rows data – replace with your images, headings & text

import img1 from "../assets/images/item1/subitm1.jpg";
import img2 from "../assets/images/item1/subitm2.jpg";
import img3 from "../assets/images/item1/subitm3.jpg";
import img4 from "../assets/images/item1/subitm4.jpg";
import img5 from "../assets/images/item1/subitm5.jpg";


const rowsData = [
  {
    id: 1,
    title: "Portable Air Conditioners",
    text: "Compact and efficient portable air conditioners for cooling any room with ease and convenience.",
    img: img1,
    gradient: "gradient1",
    stars: 4,
    description: `Portable air conditioners provide flexible and efficient cooling solutions for homes, offices, and small spaces. They are easy to install and can be moved from room to room as needed. These units come with advanced features like adjustable thermostats, timers, and multiple fan speeds.
`
  },
  {
    id: 2,
    title: "Heat Pump",
    text: "Efficient heat pumps for both heating and cooling, ensuring year-round comfort.",
    img: img2,
    gradient: "gradient2",
    stars: 5,
    description: `Heat pumps provide energy-efficient heating and cooling for residential and commercial spaces. They work by transferring heat rather than generating it, reducing energy consumption. Advanced models come with programmable thermostats and smart controls for convenience.`
  },
  {
    id: 3,
    title: "Industrial Air purifier",
    text: "High-performance industrial air purifiers for clean and safe working environments.",
    img: img3,
    gradient: "gradient3",
    stars: 3,
    description: `Industrial air purifiers remove dust, pollutants, and harmful particles from large spaces. They are designed for factories, warehouses, and other commercial facilities. With advanced filtration systems, they ensure improved air quality and healthier workplaces.
`
  },
  {
    id: 4,
    title: "Mini Split Air Conditioner",
    text: "Compact mini-split AC units for efficient and customizable room cooling.",
    img: img4,
    gradient: "gradient4",
    stars: 4,
    description: `Mini split air conditioners offer targeted cooling for individual rooms or zones. They are easy to install without ductwork, making them ideal for retrofits and new constructions. Advanced models include remote controls, timers, and energy-saving modes.
`
  },
  {
    id: 5,
    title: "Air Conditioner",
    text: "Reliable air conditioners for consistent and comfortable indoor cooling.",
    img: img5,
    gradient: "gradient5",
    stars: 5,
    description: `Air conditioners provide efficient cooling for homes, offices, and commercial spaces. They maintain a comfortable indoor temperature even during extreme heat. Modern units feature energy-saving technology, adjustable thermostats, and quiet operation.
`
  }
];

function Z1() {
  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <>
      <Navbar />

      <section className="z1-section">
        {rowsData.map((row) => (
          <div
            key={row.id}
            className={`z1-row ${row.gradient}`}
            onClick={() => setSelectedRow(row)}
          >
            <div className="z1-img">
              <img src={row.img} alt={row.title} />
            </div>

            <div className="z1-content">
              <h2>{row.title}</h2>
              <p>{row.text}</p>
              <div className="stars">
                {"★".repeat(row.stars)}
                {"☆".repeat(5 - row.stars)}
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* 🔹 Popup / Modal */}
      {/* 🔹 Popup / Modal */}
{selectedRow && (
  <div className="z1-modal-overlay" onClick={() => setSelectedRow(null)}>
    <div
      className="z1-modal"
      onClick={(e) => e.stopPropagation()} // prevent close on inner click
    >
      {/* ⭐ Heading top center */}
      <h2 className="modal-title">{selectedRow.title}</h2>

      {/* ⭐ Image left + Description right */}
      <div className="modal-body">
        <div className="modal-img">
          <img src={selectedRow.img} alt={selectedRow.title} />
        </div>
        <div className="modal-text">
          <p>{selectedRow.description}</p>
        </div>
      </div>

      {/* ⭐ Close button bottom center */}
      <button
        className="close-btn"
        onClick={() => setSelectedRow(null)}
      >
        Close
      </button>
    </div>
  </div>
)}


      <Footer />
    </>
  );
}

export default Z1;